  function nrvInit() {
    var root = document.querySelector('[data-nrv]:not([data-ready])');
    if (!root) return;
    root.setAttribute('data-ready', '1');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Reveal on scroll (same behaviour as the homepage sections)
    var rv = root.querySelectorAll('[data-nrh-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
      rv.forEach(function (el) { io.observe(el); });
    } else { rv.forEach(function (el) { el.classList.add('is-in'); }); }

    // Smooth jump for the hero buttons
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // Photo wall: filter + load more
    var grid = root.querySelector('[data-grid]');
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('[data-card]'));
    var more = root.querySelector('[data-more]');
    var STEP = parseInt(root.getAttribute('data-step'), 10) || 24;
    var filter = 'all', limit = STEP, visible = [];
    function apply() {
      visible = [];
      var shown = 0;
      cards.forEach(function (c) {
        var match = filter === 'all' || c.getAttribute('data-cat') === filter;
        var on = match && shown < limit;
        c.hidden = !on;
        if (match) { if (on) shown++; visible.push(c); }
      });
      more.hidden = visible.length <= limit;
    }
    root.querySelectorAll('[data-f]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-f]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        filter = b.getAttribute('data-f'); limit = STEP; apply();
      });
    });
    more.addEventListener('click', function () { limit += STEP; apply(); });
    apply();

    // Review viewer
    var view = root.querySelector('.nrv-view'), ci = 0;
    if (!view) return;
    function q(sel) { return view.querySelector(sel); }
    function show(i) {
      var list = visible.filter(function (c) { return !c.hidden; });
      if (!list.length) return;
      ci = (i + list.length) % list.length;
      var c = list[ci];
      q('[data-img]').src = c.getAttribute('data-src');
      q('[data-img]').alt = c.querySelector('img').alt;
      q('[data-stars]').style.setProperty('--p', c.getAttribute('data-p') + '%');
      q('[data-txt]').innerHTML = c.querySelector('template').innerHTML;
      q('[data-who]').textContent = c.getAttribute('data-who');
      q('[data-meta]').textContent = c.getAttribute('data-meta');
      var cta = q('[data-cta]');
      cta.href = c.getAttribute('data-url');
      cta.textContent = (c.getAttribute('data-avail') === 'true' ? 'Shop ' : 'View ') + c.getAttribute('data-product');
      q('[data-count]').textContent = (ci + 1) + ' / ' + list.length;
    }
    grid.addEventListener('click', function (e) {
      var c = e.target.closest('[data-card]');
      if (!c || !view.showModal) return;
      var list = visible.filter(function (x) { return !x.hidden; });
      show(list.indexOf(c));
      view.showModal();
    });
    q('[data-close]').addEventListener('click', function () { view.close(); });
    q('[data-prev]').addEventListener('click', function () { show(ci - 1); });
    q('[data-next]').addEventListener('click', function () { show(ci + 1); });
    view.addEventListener('click', function (e) { if (e.target === view) view.close(); });
    view.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(ci + 1); if (e.key === 'ArrowLeft') show(ci - 1); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nrvInit); else nrvInit();
